import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Close } from '@material-ui/icons'
import { Label } from '../default'
import { Box, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Modal, Paper, Radio, RadioGroup, Tooltip, withStyles } from '@material-ui/core'
import { useDispatch } from 'react-redux'

import { DB_CONST } from '../../class/constants'
import FormPayment from '../forms/FormPayment'
import { acClearChargeInfo } from '../../class/actions'
import FormSubscription from '../forms/FormSubscription'


function FinancialModal({
  classes, open, onClose,
  currentCustomer, fetchError, charge
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [chargeType, setChargeType] = useState(DB_CONST.CHARGE_TYPES.PAYMENT)

  useEffect(() => {
    dispatch(acClearChargeInfo())
  }, [dispatch])

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus style={{ outline: 0 }}>
      <Paper
        square={true}
        className={classes.root + ' ' + classes.modalDiv}
      >
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Grid container spacing={2} className={classes.grid}>
            <Grid item xs={8}>
              <Label v='h6'>
                {t('modals.financial.title')}
              </Label>
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'right', padding: 0 }}>
              <Tooltip title={t('default.close')}>
                <IconButton onClick={onClose}>
                  <Close />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel id='modal-financial-choose-type'>{t('modals.financial.chooseType')}</FormLabel>
                <RadioGroup row aria-labelledby='modal-financial-choose-type' name='modal-financial-choose-type-radio'
                  value={chargeType}
                  onChange={(e) => setChargeType(e.target.value)}>
                  <FormControlLabel value={DB_CONST.CHARGE_TYPES.PAYMENT} control={<Radio />} label={t('modals.financial.radio.payment')} />
                  <FormControlLabel value={DB_CONST.CHARGE_TYPES.SUBSCRIPTION} control={<Radio />} label={t('modals.financial.radio.subscription')} />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              {
                chargeType === DB_CONST.CHARGE_TYPES.PAYMENT ?
                  <FormPayment currentCustomer={currentCustomer} cancel={onClose} />
                  : <FormSubscription currentCustomer={currentCustomer} cancel={onClose} />
              }
            </Grid>
          </Grid>
        </Box>

        <div>
          <div>
          </div>
        </div>
      </Paper>
    </Modal >
  )
}

FinancialModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  close: PropTypes.func
}

FinancialModal.defaultProps = {
  open: false,
  onClose: () => true,
  close: () => true
}

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    padding: theme.spacing(2),
    maxHeight: '90%',
    overflowY: 'scroll'
  },
  grid: {
    display: 'flex',
    flex: 1
  },
  modalDiv: {
    [theme.breakpoints.up('md')]: {
      width: '35%'
    },
    width: '100%',
    top: '10%',
    left: '50%',
    transform: 'translate(-50%, -10%)',
  }
})

export default withStyles(styles)(FinancialModal)